import Vue from 'vue'
import Vuetify from 'vuetify'
import VueRouter from 'vue-router'
import Vuelidate from 'vuelidate'
import VueCookies from 'vue-cookies'

import 'es6-promise/auto'


 // index.js or main.js
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader

import { routes } from './routes';
import { store } from './store/store';

import AuthRest from './helpers/auth-rest-func.js';

Vue.use(Vuelidate)
Vue.use(VueRouter)
Vue.use(VueCookies)
Vue.use(Vuetify, {
  theme: {
    primary: "#004f80",
    secondary: "#ffb400",
    accent: "#f6511d"
  }
})

Vue.config.devtools=false

import App from './App.vue'

// set default config
VueCookies.config('7d')
// set global cookie
// VueCookies.set('theme','default');
// VueCookies.set('hover-time','1s');


// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
  mode: 'history',
  relative: true,
  base: __dirname,
  routes, // short for `routes: routes`,
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }

    // if (savedPosition) {
    //   return savedPosition
    // } else {
      return { x: 0, y: 0 }
    // }
  }
})

// function routerExceptionHandler (to, from, next) {
//   return error => {
//       switch (error.response.status) {
//           case 401:
//               console.log("router Error 401")
//               return next({ name: 'login', replace: true });
//           case 404:
//               console.log("router Error 404")
//               return next({ name: '404', params: [to.path], replace: true });
//           default:
//               return next(error);
//       }
//   };
// };

// router.onError(routerExceptionHandler);

// scroll to top on new routes
router.beforeEach(function (to, from, next) {
  // -----------------
  // Authentification
  // -----------------
  // const authPages = ['/bop-preview', '/bop-preview/'];
  // const authRequired = authPages.includes(to.path);
  // if(authRequired) {
  //   const loggedIn = AuthRest.autoCheckAuthCookie() ;

  //   if(loggedIn == false) {
  //     return next({name: "login"});
  //   }
  // }

  // -----------------
  // Ajout des meta et du titre de la page
  // -----------------

  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));


  // ------
  // Redirection des routes /<root>?<slug>=<slug_value> vers /<root>/<slug_value>
  // ------
  // --- redirection des evenements ---
  if(to.name == 'agenda') {
    let slug = to.query.slug;
    if(slug)
    {
      next({
        name:"eventId",
        params: {category: slug}
      });
      return;
    }
  }
  // ---- redrection des actus
  else if(to.name == 'actus') {
    let slug = to.query.slug;
    if(slug)
    {
      next({
        name:"actuId",
        params: {actuId: slug}
      });
      return;
    }
  }
  // ---- redrection des actus
  else if(to.name == 'galeries') {
    let slug = to.query.slug;
    if(slug)
    {
      next({
        name:"galerie",
        params: {id: slug}
      });
      return;
    }
  }
  // ---- redirection des pages equipes
  else if(to.name == 'equipes') {
    let slug = to.query.slug;
    if(slug)
    {
      next({
        name:"equipe",
        params: {category: slug}
      });
      return;
    }
  }
  // ---- redirection pages club
  else if(to.name == 'club') {
    let sub = to.query.sub;
    if(sub)
    {
      if(sub == "comite") {
        next({
          name:"comite"
        });
        return;
      } else if (sub == "equipe-technique") {
        next({
          name:"equipe-technique"
        });
        return;
      } else if (sub == "gymnases") {
        next({
          name:"gymnases"
        });
        return;
      } else if (sub == "liens-utiles-et-ressources") {
        next({
          name:"ressources"
        });
        return;
      }
    }
  }
  // ---- redirection pages mini-basket
  else if(to.name == 'mini-basket') {
    let sub = to.query.sub;
    if(sub)
    {
      if(sub == "baby-basket") {
        next({
          name:"baby-basket"
        });
        return;
      } else if (sub == "operation-basket-ecole") {
        next({
          name:"obe"
        });
        return;
      }
    }
  }
  // ---- redirection des pages sport-sante
  else if(to.name == 'sport-sante') {
    let sub = to.query.sub;
    if(sub)
    {
      if(sub == "sport-sur-ordonnance") {
        next({
          name:"sport-ordonnance"
        });
        return;
      } else if (sub == "basket-sante") {
        next({
          name:"basket-sante"
        });
        return;
      }
    }
  }
  // ---- redirection des pages sponsors
  else if(to.name == 'sponsors') {
    let sub = to.query.sub;
    if(sub)
    {
      if(sub == "partenaires") {
        next({
          name:"partenaires"
        });
        return;
      } else if (sub == "devenir-partenaire") {
        next({
          name:"partenariat"
        });
        return;
      } else if (sub == "mecenat") {
        next({
          name:"mecenat"
        });
        return;
      }
    }
  }
  next();
})

// --------------
const app = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})/*.$mount("#app")*/;

Vue.prototype.$app = app;



// WEBPACK FOOTER //
// ./src/main.js